import type { ReactNode } from 'react';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

type Props = {
  defaultValue?: boolean;
  children: (value: boolean, onToggle: (value: boolean) => void) => ReactNode;
};

export type ToggleRef = {
  set: (value: boolean) => void;
  toggle: () => void;
};

const Toggle = forwardRef<ToggleRef, Props>(
  ({ defaultValue = false, children }, ref) => {
    const [isOpen, setIsOpen] = useState(defaultValue);

    useEffect(() => {
      setIsOpen(defaultValue);
    }, [defaultValue]);

    useImperativeHandle(ref, () => ({
      set: (value: boolean) => setIsOpen(value),
      toggle: () => setIsOpen(prev => !prev)
    }));

    return children(isOpen, setIsOpen);
  }
);

export default Toggle;
